import React from "react";
import { Card, CardContent, Typography, Box, Stack } from "@mui/material";

export default function StatCard({ title, value, subtitle, icon, bg = "#fff" }) {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 4,
        border: "1px solid #e2e8f0",
        background: bg,
        height: "100%",
      }}
    >
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography sx={{ color: "#64748b", fontWeight: 700 }}>{title}</Typography>
          {icon ? (
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: 2,
                bgcolor: "#eef2ff",
                display: "grid",
                placeItems: "center",
              }}
            >
              {icon}
            </Box>
          ) : null}
        </Stack>

        <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a" }}>
          {value}
        </Typography>

        {subtitle ? (
          <Typography sx={{ mt: 1, color: "#64748b", fontSize: 14 }}>
            {subtitle}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}